import { Text } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";
import { useConductorResource } from "../../hooks/useConductorResource";

interface Props {
  values: string[];
  onChange: (values: string[]) => void;
}

// Tenants are a closed set, so they are picked rather than typed. The options
// come from the server because they mirror merge-backend's Environment enum,
// which a hardcoded copy would drift from. A value the flag already holds but
// that is no longer offered still renders, so editing never silently drops it.
const TenantSelectField = ({ values, onChange }: Props) => {
  const { data: tenants } = useConductorResource<string[]>("/conductor/flag-tenants");
  const known = tenants || [];
  const unknown = values.filter((value) => !known.includes(value));
  const options = [...known, ...unknown];

  const toggle = (tenant: string) =>
    onChange(
      values.includes(tenant) ? values.filter((value) => value !== tenant) : [...values, tenant]
    );

  return (
    <div>
      <div className="mb-1 flex items-baseline gap-2">
        <Text variant="sm" className="text-gray-60">
          Tenants
        </Text>
        <Text variant="sm" className="text-gray-40">
          {values.length === 0 ? "all tenants" : `${values.length} selected`}
        </Text>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {options.map((tenant) => {
          const selected = values.includes(tenant);
          return (
            <button
              key={tenant}
              onClick={() => toggle(tenant)}
              aria-pressed={selected}
              className={clsx(
                "rounded-md border px-2 py-1 font-mono text-sm",
                selected
                  ? "border-blue-40 bg-blue-0 text-blue-60"
                  : "border-gray-20 bg-white text-gray-60 hover:bg-gray-0"
              )}
            >
              {tenant}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TenantSelectField;
